import { render } from "./MfcProjectSelector.vue?vue&type=template&id=0394a0c0"
import script from "./MfcProjectSelector.vue?vue&type=script&lang=js"
export * from "./MfcProjectSelector.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__